import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import {
  addProgramRequest,
  addProgramSuccess,
  addProgramFailure,
} from '../reducers/addProjectCode';
import { API_LINK } from '../../constants';
import { authUserRequest } from '../reducers/login';

const API = `${API_LINK}api/addProgramCode`;

function* addProgramFunctionAxios() {
  const state = yield select(fullState => fullState);
  const {
    user: { userId },
    token,
  } = state.loginReducer;
  const programCode = state.form.addCodeForm.values.Code;

  const response = yield call(() =>
    axios({
      method: 'post',
      url: API,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
        Authorization: `Bearer ${token}`,
      },
      credentials: 'same-origin',
      data: {
        userId,
        programCode,
      },
    }),
  );

  return response;
}

function* workerAddProgramSaga() {
  try {
    const response = yield call(addProgramFunctionAxios);

    const responseFromAddProgram = response.data;
    if (response.status === 200) {
      yield put(addProgramSuccess(responseFromAddProgram));
      yield put(authUserRequest())
    }
    if (response.status === 205) {
      yield put(addProgramFailure(responseFromAddProgram));
    }
    if (response.status === 206) {
      yield put(addProgramFailure(responseFromAddProgram));
    }
    if (response.status === 207) {
      yield put(addProgramFailure(responseFromAddProgram));
    }
  } catch (error) {
    yield put(addProgramFailure(error.response));
  }
}

export function* watcherAddProgramSaga() {
  yield takeLatest(addProgramRequest().type, workerAddProgramSaga);
}
